import SrpListingAlert from './SrpListingAlert';

export default SrpListingAlert;
